module.exports = __webpack_public_path__ + "img/maneken_pos_1_back.3412c68e.png";